import { defineType } from "sanity";
const blogDatasetName = (stage = "dev") => `blog-${stage}`;

export default defineType({
  name: "blogSection",
  title: "Blog Section",
  type: "object",
  preview: {
    select: {
      title: "intro.title"
    }
  },
  fields: [
    {
      name: "intro",
      title: "Section Intro",
      type: "sectionIntro"
    },
    {
      name: "articles",
      description: "Posts from old blog",
      title: "Articles",
      type: "array",
      of: [
        {
          type: "blogArticle"
        }
      ]
    },
    {
      name: "posts",
      title: "Posts",
      description: "Posts from new blog",
      type: "array",
      of: [
        {
          type: "crossDatasetReference" as const,
          dataset: blogDatasetName(process.env.SANITY_STUDIO_API_DATASET),
          weak: true,
          options: {
            sort: [
              { field: "publishDate", direction: "desc" },
              { field: "_updatedAt", direction: "desc" },
              { field: "title", direction: "asc" }
            ],
            disableNew: true
          },
          to: [
            {
              type: "blog.post",
              preview: {
                select: {
                  title: "title",
                  subtitle: "mainCategory.title",
                  media: "featuredMedia",
                  description: "publishDate"
                }
              }
            }
          ]
        }
      ]
    },
    {
      name: "linkText",
      title: "Link Text",
      type: "multilingualArrayString"
    },
    {
      type: "ctaButtons",
      name: "ctaButtons",
      title: "CTA Buttons",
      options: {
        collapsible: true,
        collapsed: true
      }
    }
  ]
});
